import { fullKey, getVolatileStorage, IStorage, Keys } from "./common";

const storage: IStorage = isLocalStorageAvailable() ? localStorage : getVolatileStorage("local");

export function getLastModemSwapDisplay(): Date | null {
    const timestamp = storage.getItem(fullKey(Keys.LastModemSwapDisplay))
    if (timestamp != null) {
        const tsn = Number(timestamp);
        if (Number.isFinite(tsn)) {
            const d = new Date(tsn);
            if (!isNaN(d.getTime())) {
                // The Date is valid
                return d
            }
        }
    }
    return null;
}

export function setLastModemSwapDisplay(date: Date) {
    storage.setItem(fullKey(Keys.LastModemSwapDisplay), String(date.getTime()));
}

function isLocalStorageAvailable(): boolean {
    try {
        const storage = window["localStorage"];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}